module.exports = __webpack_public_path__ + "static/jbento-sc_960x320-5c938fe8dbaa99cab7f0a6f1ea63b594.png";